import { render, staticRenderFns } from "./recommendProject.vue?vue&type=template&id=357a7cff"
import script from "./recommendProject.vue?vue&type=script&lang=js"
export * from "./recommendProject.vue?vue&type=script&lang=js"
import style0 from "./recommendProject.vue?vue&type=style&index=0&id=357a7cff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports